import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { MessageEventService } from "@obg/ngx.global.evo";
import { SignalrAction } from "@obg/ngx.real-time.signalr";
import { filter, map, tap } from "rxjs/operators";

import { AamsGameDataAction } from "./aams-game-data.action";
import { RealTimeAAMSConfig } from "./aams-game-data.config";

@Injectable()
export class AAMSGameDataEffect {
	constructor(
		private actions$: Actions,
		private readonly config: RealTimeAAMSConfig,
		private messageEventService: MessageEventService
	) {}

	subscribeToAAMSSessionUpdate$ = createEffect(() =>
		this.actions$.pipe(
			ofType(AamsGameDataAction.gameReady),
			filter(() => !!this.config.isEnabled()),
			map(() => SignalrAction.subscribeToCustomerTransmitChannel(this.getSessionUpdateChannel()))
		)
	);

	aamsSessionUpdateMessage$ = createEffect(() =>
		this.actions$.pipe(
			ofType(SignalrAction.customerTransmitChannelMessage),
			filter(({ channel }) => channel.startsWith(this.getSessionUpdateChannel())),
			map(({ message }) => JSON.parse(message)),
			tap((message) => this.sendAamsUpdateSessionMessage(message)),
			map((message) => AamsGameDataAction.gameSessionUpdated(message))
		)
	);

	private sendAamsUpdateSessionMessage(payload: any) {
		this.messageEventService.postMessage({
			message: "gaming/updateAams",
			data: payload,
		});
	}

	private getSessionUpdateChannel(): string {
		return `${this.config.getSessionUpdateTopic()}`;
	}
}
